import { Download, MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { VideoEmbed } from "./VideoEmbed";

export const SetupGuide = ({ s, onClose, help }) => (
  <Dialog open={!!s} onOpenChange={(v) => { if (!v) onClose(); }}>
    <DialogContent data-testid="setup-guide"
      className="max-w-lg w-[calc(100%-2rem)] max-h-[90vh] overflow-y-auto rounded-[28px] border border-white/10 bg-[#0d0b3d] p-0 text-white sm:rounded-[28px] [&>button]:text-white [&>button]:opacity-80 [&>button]:z-10">
      {s && (
        <>
          <div className="relative h-36 md:h-44">
            <img src={`/img/set-${s.id}.jpg`} alt={s.title} className="absolute inset-0 h-full w-full object-cover" />
            <span className="absolute inset-0 bg-gradient-to-t from-[#0d0b3d] via-[#0d0b3d]/60 to-transparent" />
            <div className="absolute bottom-4 left-6 right-6">
              <p lang="en" className="text-xs uppercase tracking-[0.25em] text-[#c9c6f0]">{s.app}</p>
              <DialogTitle className="mt-1 font-display text-2xl font-semibold" data-testid="setup-guide-title">{s.title} kurulumu</DialogTitle>
            </div>
          </div>
          <div className="px-6 pb-6 pt-2">
            <DialogDescription className="text-sm text-[#c9c6f0]">{s.video ? "Videoyu izle, 3 kısa adımda izlemeye başla." : "3 kısa adımda izlemeye başla."}</DialogDescription>
            <VideoEmbed url={s.video} title={`${s.title} kurulum videosu`} />
            <ol className="mt-5 space-y-4">
              {(s.steps || []).map((t, i) => (
                <li key={i} className="flex gap-4" data-testid={`setup-guide-step-${i + 1}`}>
                  <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-[#5b5fd6] font-display text-sm font-bold">{i + 1}</span>
                  <p className="pt-1 text-sm md:text-base leading-relaxed text-white/90">{t}</p>
                </li>
              ))}
            </ol>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a href={s.url} target="_blank" rel="noreferrer" data-testid="setup-guide-download"
                className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-white px-6 py-3.5 font-semibold text-[#0d0b3d] hover:bg-[#8a8dff] hover:text-white transition-colors">
                <Download size={17} /> Uygulamayı indir
              </a>
              <a href={help} target="_blank" rel="noreferrer" data-testid="setup-guide-help"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-5 py-3.5 text-sm font-semibold hover:bg-white/10 transition-colors">
                <MessageCircle size={16} /> Yardım al
              </a>
            </div>
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
